<template>
  <div>
    <div class>
      <div class="py-4 pt-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Choose period:</label>
        <div class="inline-block relative">
          <select
            class="appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            v-model="period"
          >
            <option></option>
            <option
              v-for="(period, id) in periods"
              :value="period.value"
              :key="id"
            >{{ period.name }}</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        <!-- <div class="py-4">
            <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
            <input type="radio" v-model="finished" name="toggle" id="toggle" class="toggle-checkbox outline-none absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"/>
            <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
            </div>
            <label for="toggle" class="text-xs text-gray-700">Te perfunduara</label>
        </div>-->
        <div class="py-4">
          <!-- <label class="inline-flex items-center mt-3">
                <input type="radio" class="form-radio h-5 w-5 text-red-600" checked><span class="ml-2 text-gray-700">label</span>
          </label>-->
          <label class="inline-flex items-center mt-3">
            <input type="radio" class="p-2 form-radio h-4 w-4" value v-model="finished" id />
            <span class="ml-2 pr-2 text-gray-700">All</span>
          </label>
          <label class="inline-flex items-center mt-3">
            <input type="radio" class="p-2 form-radio h-4 w-4" value="1" v-model="finished" id />
            <span class="ml-2 pr-2 text-gray-700">Finished</span>
          </label>
          <label class="inline-flex items-center mt-3">
            <input type="radio" class="p-2 form-radio h-4 w-4" value="0" v-model="finished" id />
            <span class="ml-2 pr-2 text-gray-700">Unfinished</span>
          </label>
          <!-- <label for class="p-2 ">Te pa perfunduara</label> -->
        </div>
        <div class="flex">
          <router-link
            to="/add-fast-task"
            class="block mr-3 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Add</router-link>
          <button
            @click="filterTasks"
            class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Filter</button>
          <button
            class="block ml-3 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
            @click="print"
          >Print</button>
          <router-link
            to="/finished-tasks"
            tag="button"
            class="block ml-3 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Finished Tasks</router-link> 
          <!-- <button
            @clic>k="finishedTasksUser"
            class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Finished Tasks</button  -->
          <router-link
            to="/excel"
            tag="button"
            class="block ml-3 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Back</router-link>
        </div>
      </div>
    </div>
    <div v-if="fastTasks === undefined">
      <clip-loader :color="color"></clip-loader>
    </div>
    <div v-else class="flex flex-col py-4" id="print">
      <div class v-if="!error">
        <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400">
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                >NR</th>
                <th
                  class="px-2 py-2 border w-2/6 border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
                >TITLE</th>
                <th
                  class="px-2 py-2 border w-1/6 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >DESCRIPTION</th>
                <th
                  class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >PRIORITY</th>
                <th
                  class="px-2 py-2 w-30 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >DL</th>
                <!-- <th
                  class="px-2 py-2 w-6 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >FINISHED</th> -->
                <th
                  class="px-2 py-2 w-6 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >STATUS</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >CREATOR</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >DEVELOPER</th>
                <th
                  class="px-2 py-2 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
                >COMMENT</th>
                <th class="px-2 py-2 border w-6 border-gray-400 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr
                v-for="(fastTask, index) in fastTasks"
                :key="index.id"
                :class="
                  [fastTask.done === 1
                    ? 'bg-green-200'
                    : fastTask.overdue
                    ? 'bg-red-400'
                    : '']"
              >
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ ++index }}</td>
                <td
                  class="px-2 py-2 w-2/6 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                  :class="
                    fastTask.title.substring(0, 3) === '!!!'
                      ? 'text-red-600'
                      : ''
                  "
                >{{ fastTask.title }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ fastTask.comment }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ fastTask.priority }}</td>
                <td
                  class="px-2 py-2 w-30 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ formatDate(fastTask.day) }}</td>
                <!-- <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >
                  <div v-if="fastTask.done === 1" class="text-center">
                    YES
                  </div>
                </td> -->
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >
                  {{ fastTask.status }}
                </td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ fastTask.user }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ fastTask.developer }}</td>
                <td
                  class="px-2 py-2 border text-sm border-gray-400 leading-5 font-medium text-gray-900"
                >{{ fastTask.description }}</td>
                <td class="border border-gray-400 text-sm leading-5 font-medium">
                  <router-link
                    :to="{
                      name: 'edit-fast-task',
                      params: { id: fastTask.id },
                    }"
                  >
                    <span
                      class="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline"
                    >Update</span>
                  </router-link>
                  <span class="ml-2">
                    <button
                      @click="deleteFastTask(fastTask.id)"
                      class="text-indigo-600 font-semibold hover:text-indigo-900 focus:outline-none focus:underline"
                    >Delete</button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  components: {
    ClipLoader,
  },
  props: {
    date: String,
    user: Number,
  },
  data() {
    return {
      fastTasks: [],
      finishedTasksUsers:[],
      today: new Date(),
      error: false,
      id: this.$route.params.id, 
      color: "#40E0D0",
      periods: [
        { id: 1, name: "Today", value: "day" },
        { id: 2, name: "This week", value: "week" },
        { id: 3, name: "This month", value: "month" },
        { id: 4, name: "All", value: "all" },
        { id: 5, name: "Upcoming", value: "upcoming" },
        { id: 5, name: "Tomorrow", value: "tomorrow" },
      ],
      period: null,
      finished: null,
      url: "",
    };
  },
  created() {
    this.getFastTasks();
  },
  methods: {
    getFastTasks() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/detyrat-e-shpejta`)
        .then((response) => {
          this.fastTasks = response.data.data;
        })
        .catch((error) => console.log(error));
    },
    hide() {
      this.$modal.hide("edit-task");
    },
    deleteFastTask(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (confirm("A jeni i sigurt qe deshironi ta fshini detyren?")) {
        axios
          .delete(`${process.env.VUE_APP_API}/excel/detyrat-e-shpejta/${id}`)
          .then(() => {
            this.$notify({
              group: "address",
              title: "Task",
              text: "Task was deleted",
            });

            const index = this.fastTasks.findIndex(
              (fastTask) => fastTask.id === id
            ); // find the task index
            if (~index)
              // if the task exists in array
              this.fastTasks.splice(index, 1); //delete the task
          })
          .catch((error) => console.log(error));
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    filterTasks() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      this.url = `${process.env.VUE_APP_API}/excel/detyrat-e-shpejta`;

      if (this.period) {
        this.url += `?period=${this.period}`;
      }

      if (this.period && this.finished) {
        this.url += `&done=${this.finished}`;
      }

      if (!this.period && this.finished) {
        this.url += `?done=${this.finished}`;
      }

      axios.get(`${this.url}`).then((response) => {
        this.fastTasks = response.data.data;
        // console.log(response);
      });
      console.log(this.period);
    },
    print() {
      this.$htmlToPaper("print");
    },
    finishedTasksUser() {
         axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/detyrat-e-kryera/users`)
        .then((response) => {
          console.log(response);
          this.finishedTasksUsers = response.data.data;
        })
        .catch((error) => console.log(error));

    },
  }, 
};
</script>

<style scoped></style>
